import api from './api';

export default (id) => `${api.getMedia}/${id}`;
